(function () {
  'use strict';
  /* Fenetre de recherche du header : ouverture/fermeture, focus, Echap,
     retour du focus sur la loupe. La recherche elle-meme est assuree par
     <predictive-search> (Dawn : search-form.js + predictive-search.js). */
  var modal = document.getElementById('tpSearchModal');
  var openers = document.querySelectorAll('[data-tp-search-open]');
  if (!modal || !openers.length) return;
  var input = modal.querySelector('input[type="search"]');
  var lastOpener = null;
  /* La fenetre est rendue dans la section header (sticky, z-index 100 =
     contexte d'empilement) : pendant l'ouverture, la section passe au-dessus
     du bandeau cookies (classe is-search-open, toudoupet-search.css). */
  var section = modal.closest('.shopify-section');

  /* Elements reellement tabulables : exclut tabindex="-1" (resultats Dawn,
     pilotes aux fleches), desactives et masques (bouton reset .hidden). */
  function tabbables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]'),
      function (el) { return !el.disabled && el.tabIndex >= 0 && el.offsetParent !== null; }
    );
  }

  function open(opener) {
    /* Une seule modale a la fois : pas d'ouverture si le popup promo est affiche. */
    var promo = document.getElementById('tpPromo');
    if (promo && !promo.hidden) return;
    lastOpener = opener || null;
    modal.hidden = false;
    if (section) section.classList.add('is-search-open');
    /* Verrou de defilement sur <html> (regle commune, toudoupet-header.css) ; la classe
       du body reste un simple indicateur d'etat (masque la pastille promo). */
    document.documentElement.classList.add('tp-search-open');
    document.body.classList.add('tp-search-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    window.setTimeout(function () { if (input) { input.focus(); input.select(); } }, 20);
  }
  function close() {
    if (modal.hidden) return;
    modal.hidden = true;
    if (section) section.classList.remove('is-search-open');
    document.documentElement.classList.remove('tp-search-open');
    document.body.classList.remove('tp-search-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastOpener) lastOpener.focus();
  }

  openers.forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); open(btn); }); });
  modal.querySelectorAll('[data-tp-search-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) { e.preventDefault(); close(); }
    /* Piege de focus : Tab / Maj+Tab restent dans le panneau, avec ou sans resultats */
    if (e.key === 'Tab' && !modal.hidden) {
      var focusables = tabbables();
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (!modal.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();